import { getEventFromValue } from "shared/topchef.types";

export interface EventTypeRendererProps {
  eventValue: string | ''
}

const EventTypeRenderer = (props: EventTypeRendererProps) => {
    const eventType = getEventFromValue(props.eventValue);
    return (
      <div>
        {eventType.label}
      </div>
    );

  };

  export default EventTypeRenderer;
